import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api, { setToken } from '../lib/api';

const AuthContext = createContext({});

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  // Try to restore session from localStorage on mount
  useEffect(() => {
    const token = localStorage.getItem('gt_token');
    if (!token) { setLoading(false); return; }
    api.get('/auth/me')
      .then(data => setUser(data.user))
      .catch(() => { setToken(null); })
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const data = await api.post('/auth/login', { email, password });
    setToken(data.token);
    setUser(data.user);
    return data;
  }, []);

  const logout = useCallback(() => {
    setToken(null);
    setUser(null);
  }, []);

  const refreshUser = useCallback(async () => {
    const data = await api.get('/auth/me');
    setUser(data.user);
  }, []);

  const isSuperAdmin = user?.role === 'super_admin';
  const isAdmin  = user?.role === 'admin' || isSuperAdmin;
  const isTech   = user?.role === 'tech';
  const isClient = user?.role === 'client';
  const isStaff  = isAdmin || isTech;

  return (
    <AuthContext.Provider value={{
      user, loading, login, logout, refreshUser,
      isAdmin, isSuperAdmin, isTech, isClient, isStaff,
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
